export { default } from "./AddTextSetIcon";
